/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2022/4/11 14:14
 * @des  异常处理
 */

import {Message} from 'element-ui'

/**
 * 未知错误
 */
export const UNKNOWN = 2000

/**
 * 网络错误
 */
export const NETWORK_ERROR = 2006

/**
 * 是否是网络错误
 * @param errorInfo
 * @returns {boolean}
 */
export function isNetworkErr (errorInfo) {
  if (errorInfo.code === NETWORK_ERROR) {
    return true
  }
  return false
}

/**
 * 本地异常
 */
export function handleNativeException (error) {
  let errorInfo = {
    code: UNKNOWN,
    message: ''
  }
  errorInfo.showErr = true
  errorInfo.toLogin = false
  if (error && error instanceof Error) {
    errorInfo.message = error.message
    if (error.code && parseInt(error.code) < 1000) {
      errorInfo.message = `Error:${error.code}`
    }
    if (error.message === 'Network Error') {
      errorInfo.code = NETWORK_ERROR
    }
  }
  setTimeout(() => {
    if (errorInfo.showErr) {
      Message({
        type: 'warning',
        message: errorInfo.message
      })
    }
  }, 0)
  return errorInfo
}

/**
 * 服务端异常
 */
export function handleServiceException (code, msg, showToast) {
  let errorInfo = {
    code: code,
    message: msg
  }
  if (showToast) {
    Message({
      type: 'warning',
      message: msg
    })
  }
  return errorInfo
}



// WEBPACK FOOTER //
// ./src/base/util/exeptionutil.js